import { PurchaseManagementRightMenuStructure } from "../store";
import { PURCHASE_MANAGEMENT_RIGHT_MENU } from '../actions-constants/purchaseManagementRightMenu.constants'
const initialPurchaseManagementRightMenuStructure: PurchaseManagementRightMenuStructure = new PurchaseManagementRightMenuStructure

export function purchaseManagementRightMenuReducer(purchaseManagementRightMenu: PurchaseManagementRightMenuStructure = initialPurchaseManagementRightMenuStructure, action): PurchaseManagementRightMenuStructure {

    switch (action.type) {
        case PURCHASE_MANAGEMENT_RIGHT_MENU.SET_INITIAL_DATE:
            return {
                ...purchaseManagementRightMenu,
                initialDate: action.initialDate
            }

        case PURCHASE_MANAGEMENT_RIGHT_MENU.SET_FINAL_DATE:
            return {
                ...purchaseManagementRightMenu,
                finalDate: action.finalDate
            }

        case PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_SITUATIONS:
            return {
                ...purchaseManagementRightMenu,
                stateSituations: action.stateSituations
            }

        case PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_TYPE:
            return {
                ...purchaseManagementRightMenu,
                stateType: action.stateType
            }

        case PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_PROVIDER_ID:
            return {
                ...purchaseManagementRightMenu,
                providerId: action.providerId
            }

        default:
            return purchaseManagementRightMenu
    }
}
